import { colNameType, pqIndexResult } from "./pqIndexTypes";
import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./pqIndexStyle";
import ColorValues from "./colorTableCell";
import LegendePQIndex from "./legendePQIndex";

export default function MessstelleZeitGrid(
    props: {
        uw: string,
        kategorie: string,
        liste_header: Array<colNameType>,
        liste_horizental: Array<number>,
        liste_vertikal: Array<number>,
        min_all: number,
        pqIndex: Array<Array<pqIndexResult>>
    }
): ReactElement {

    const classes = {

        ...globalStyles(),
        ...useStyles()
    };

    const messstellenZeit = props.pqIndex;
    const kwListe = props.liste_header;
    const minMessstelleListe = props.liste_vertikal;
    const minZeitListe = props.liste_horizental;
    const minValueAll = props.min_all;

    function createTableCell(kwElem: colNameType, rows: pqIndexResult[]) {
        const rowsMaxIndex = rows.length
        let rowsIndex = 0;
        const cellValue = 11;
        while (rowsMaxIndex > rowsIndex) {
            // eslint-disable-next-line security/detect-object-injection
            if (kwElem.col == rows[rowsIndex].col) {
                // eslint-disable-next-line security/detect-object-injection
                return (<ColorValues value={rows[rowsIndex].value} />)
            }
            rowsIndex += 1;
        }
        return (<ColorValues value={cellValue} />)
    }

    return (
        <React.Fragment>
            <Grid item md={12} style={{ textAlign: 'left', marginRight: "20px" }}>
                <div >
                    <LegendePQIndex />
                    <TableContainer component={Paper} style={{ height: '80vh' }}>
                        <Table aria-label="simple table" className={classes.table}>
                            <TableHead >
                                <TableCell className={classes.tableHeaderHorizontalLeftmost}>Messstelle / KW</TableCell>
                                {kwListe.map((elem, index) => (
                                    <TableCell key={index} className={classes.tableHeaderHorizontal}>{elem.name}</TableCell>
                                ))}
                                <TableCell className={classes.tableHeaderHorizontalBlank} style={{ width: "20px" }} />
                                <TableCell className={classes.tableHeaderHorizontal}>Alle Messstellen</TableCell>
                            </TableHead>
                            <TableBody>
                                {messstellenZeit.map((rows, index) => (
                                    <TableRow key={rows[0].row} >
                                        <TableCell className={classes.tableHeaderVertical} component="th" scope="rows" >{rows[0].row}</TableCell>
                                        {kwListe.map((kwElem) =>
                                            createTableCell(kwElem, rows)
                                        )}
                                        <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                        {/* eslint-disable-next-line security/detect-object-injection */}
                                        <ColorValues value={minMessstelleListe[index]} />
                                    </TableRow>
                                ))}
                                <TableRow >
                                    <TableCell />
                                </TableRow>
                                <TableRow >
                                    <TableCell style={{ width: "295px" }} component="th" scope="rows" className={classes.tableHeaderVertical}>Gesamte Zeit</TableCell>
                                    {minZeitListe.map((elem, index) => (
                                        <ColorValues value={elem} key={index} />
                                    ))}
                                    <TableCell className={classes.tableCellBlank} style={{ width: "20px" }} />
                                    <ColorValues value={minValueAll} />
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Grid>
        </React.Fragment>
    );
}
